import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const EMPTY = { name: "", email: "", password: "", region: "" };
const fc = "bg-[#0B0907] border-[#D4AF37]/20";

export function Manufacturers({ list, reload }) {
  const [f, setF] = useState(EMPTY);
  const ch = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/manufacturers", f);
      toast.success("Manufacturer account created");
      setF(EMPTY);
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const remove = async (m) => {
    if (!window.confirm(`Remove ${m.name}?`)) return;
    await api.delete(`/admin/manufacturers/${m.id}`);
    reload();
  };

  return (
    <div className="grid lg:grid-cols-2 gap-8" data-testid="manufacturers-panel">
      <form onSubmit={create} className="rounded-sm border border-[#D4AF37]/15 bg-[#14110E] p-6 space-y-3 h-fit" data-testid="manufacturer-form">
        <h2 className="font-display text-xl">New manufacturer</h2>
        <Input required placeholder="Name / weaving unit" value={f.name} onChange={ch("name")} className={fc} data-testid="mfr-name" />
        <Input placeholder="Region e.g. Kanchipuram" value={f.region} onChange={ch("region")} className={fc} data-testid="mfr-region" />
        <Input required type="email" placeholder="Login email" value={f.email} onChange={ch("email")} className={fc} data-testid="mfr-email" />
        <Input required minLength={6} placeholder="Password (min 6)" value={f.password} onChange={ch("password")} className={fc} data-testid="mfr-password" />
        <button className="btn-glow w-full rounded-full bg-[#D4AF37] py-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#0B0907]" data-testid="mfr-submit">Create account</button>
      </form>
      <div className="space-y-2">
        {list.length === 0 && <p className="text-[#6E6558] text-sm">No manufacturers yet.</p>}
        {list.map((m) => (
          <div key={m.id} className="flex items-center justify-between rounded-sm border border-[#D4AF37]/10 bg-[#14110E] p-4" data-testid={`mfr-row-${m.id}`}>
            <div>
              <p className="text-sm">{m.name} {m.region && <span className="font-serif-it text-[#A89F91]">· {m.region}</span>}</p>
              <p className="text-xs text-[#6E6558]">{m.email}</p>
            </div>
            <button onClick={() => remove(m)} className="p-2 text-[#A89F91] hover:text-[#E06D3B]" data-testid={`mfr-delete-${m.id}`} aria-label="Remove"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
